// extracted by mini-css-extract-plugin
export default {"container":"CompanyPage_container__i-+lu"};